var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('page-main-aside-layout');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { ItemList } from '../elements/item-list';
import { MainAside } from '../elements/main-aside';
import { ParentCard } from './parent-card';
import { PersonLink } from './person-link';
import { usePageContentLayout } from './page-content-layout';
import { pick } from 'lodash';
export var PageMainAsideLayoutDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: 1em;\n    padding: ", " ", ";\n  "], ["\n    font-size: 1em;\n    padding: ", " ", ";\n  "])), theme.UNIT(5), theme.UNIT(4)),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", ";\n\n  "], ["\n    padding: ", " ", ";\n\n  "])), theme.UNIT(6), theme.UNIT(4)),
  desktopLarge: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", " ", ";\n  "], ["\n    padding: ", " ", ";\n  "])), theme.UNIT(6), theme.UNIT(4))
});
var PullStyles = breakpoints({
  tablet: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-right: -", ";\n  "], ["\n    margin-right: -", ";\n  "])), theme.UNIT(3)),
  desktop: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-right: -", ";\n  "], ["\n    margin-right: -", ";\n  "])), theme.UNIT(4))
});
var PeopleStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", ";\n    margin-bottom: ", ";\n  "], ["\n    ", ";\n    margin-bottom: ", ";\n  "])), PullStyles, theme.UNIT(4))
});
var PersonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var TrendsStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    ", ";\n    margin-bottom: ", ";\n  "], ["\n    ", ";\n    margin-bottom: ", ";\n  "])), PullStyles, theme.UNIT(4))
});
var TrendStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  "], ["\n  "])))
}); // -------- Components -------->

var My = {
  Container: styled(MainAside)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  People: styled(ItemList)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), PeopleStyles),
  Person: styled(PersonLink)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles),
  Trends: styled(ItemList)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), TrendsStyles),
  Trend: styled(ParentCard)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), TrendStyles),
  Aside: React.Fragment
};
export var PageMainAsideLayout = function PageMainAsideLayout(props) {
  var className = props.className,
      entity = props.entity,
      rest = __rest(props, ["className", "entity"]);

  var mainAsideProps = pick(rest, 'asideRatio', 'asideHead', 'asideFoot', 'mainHeader', 'mainFooter', 'space', 'showAsideHead', 'showAsideFoot');
  var _a = entity.people,
      people = _a === void 0 ? [] : _a,
      trends = entity.trends;
  var hasPeople = !!people.length;
  var hasTrends = !!trends;
  var contentProps = pick(props, 'showIntro', 'showOutro', 'showContent');
  var Content = usePageContentLayout();
  return React.createElement(My.Container, __assign({
    className: cls.name(className)
  }, mainAsideProps, {
    main: React.createElement(Content, __assign({
      entity: entity
    }, contentProps)),
    aside: React.createElement(My.Aside, null, hasPeople && React.createElement(My.People, {
      items: people.map(function (person) {
        return React.createElement(My.Person, {
          key: person.slug,
          entity: person
        });
      })
    }), hasTrends && React.createElement(My.Trends, {
      items: trends.map(function (trend) {
        return React.createElement(My.Trend, {
          label: "Scientific Platform:",
          key: trend.slug,
          entity: trend
        });
      })
    }))
  }));
};
PageMainAsideLayout.defaultProps = PageMainAsideLayoutDefaultProps;
PageMainAsideLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;